export default __webpack_public_path__ + "614593c0439dcee500ed6aa3ae37d4ac.png";